// src/pages/ThankYou.js
import React from "react";

function ThankYou() {
  return (
    <div className="thankyou-page">
      <div className="thankyou-card">
        <div className="thankyou-icon">
          <i className="fas fa-check"></i>
        </div>
        <h1>Thank You! 🎉</h1>
        <p>Your message has been sent successfully.</p>
        <p>
          Our team will review your request and get back to you within <strong>24 hours</strong>.
          We're excited to work with you!
        </p>
        <a href="/" className="btn-primary">
          ← Back to Home
        </a>
      </div>
    </div>
  );
}

export default ThankYou;
